import Api from 'utils/api'

export const uploadPhotoReq = async (image) => {
	try {
		const data = new FormData()
		data.append('file', image)
		return await Api.post('/return-orders/reclamation/image', data, {
			'Content-Type': 'multipart/form-data;',
		})
	} catch (error) {
		console.log(error)
	}
}
export const removePhotoReq = async (id) => {
	try {
		return await Api.delete(`return-orders/reclamation/image/${id}`)
	} catch (error) {
		console.log(error)
	}
}
